// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.104.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.104.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
h1,
h2,
h3,
h4,
h5,
h6 {
  margin-top: 0;
  margin-bottom: 0.5em;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
}
a {
  color: #1890ff;
  text-decoration: none;
  background-color: transparent;
  outline: none;
  cursor: pointer;
  transition: color 0.3s;
  -webkit-text-decoration-skip: objects;
}
a:hover {
  color: #40a9ff;
}
a:active {
  color: #096dd9;
}
a:active,
a:hover {
  text-decoration: none;
  outline: 0;
}
a:focus {
  text-decoration: none;
  outline: 0;
}
a[disabled] {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

.loading-overlay {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    margin: 0 -15px;
    background-color: rgba(255, 255, 255, 0.75);
    transition: all 0.4s ease;
    transform: scale(1);
    opacity: 1;
    z-index: 5;
    display: block;
}
.loading-indicator {
    height: 110px;
    left: 50%;
    margin: -55px 0 0 -55px;
    position: absolute;
    text-align: center;
    top: 50%;
    width: 110px;
}

html {
  height: 100%;
  overflow: hidden;
}
body {
  height: 100vh;
  overflow-x: hidden;
}
#app-root {
  height: 100%;
}
.root-layout {
  height: 100%;
}
.ant-layout.page-layout {
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
}
.ant-layout-content.page-content {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}
.ant-layout-content.page-content .ant-table-wrapper {
  margin: 0 24px 24px 24px;
}
.ant-layout-header.page-header {
  background: transparent;
  padding: 0 24px;
  display: flex;
  align-items: center;
  height: 80px;
}
.ant-layout-header.page-header > .ant-row {
  width: 100%;
}
.page-drawer {
  top: 64px;
  height: calc(100vh - 64px);
}
.ant-layout-content.page-content {
  flex-shrink: 0;
}
.ant-layout-content.page-content .ant-table-wrapper {
  margin: 0 24px 24px 24px;
}
.ant-layout-content.app-content {
  flex-shrink: 0;
}
.ant-breadcrumb-link > a > .anticon + span {
  margin-left: 4px;
}
.ant-breadcrumb-link > a {
  border-bottom: 1px solid #999;
}
.ant-layout {
  display: flex;
  flex: auto;
  flex-direction: column;
  min-height: 0;
  background: #f0f2f5;
}
.cmx-page-drawer .ant-collapse {
  border-radius: 2px;
}
.cmx-page-drawer .ant-input {
  border-radius: 2px;
}
.cmx-page-drawer .ant-table-wrapper .ant-table.ant-table-bordered > .ant-table-container {
  border-radius: 0px;
}
.cmx-page-drawer .ant-btn {
  border-radius: 2px;
}
.cmx-page-drawer .ant-btn-primary {
  color: #fff;
  border-color: #1890ff;
  background: #1890ff;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
}
.cmx-page-drawer collapse-item:last-child > .ant-collapse-header {
  border-radius: 0 0 2px 2px;
}
.cmx-page-drawer .ant-collapse {
  padding-bottom: 0px;
}
.cmx-page-drawer .ant-collapse > .ant-collapse-item > .ant-collapse-header {
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-start;
  padding: 12px 16px;
  color: rgba(0, 0, 0, 0.88);
  line-height: 0;
  cursor: pointer;
  transition: all 0.3s, visibility 0s;
}
.cmx-page-drawer .ant-collapse.ant-collapse-icon-position-end > .ant-collapse-item > .ant-collapse-header .ant-collapse-expand-icon {
  margin-top: 4px;
}
.cmx-page-drawer .ant-collapse {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: 'tnum';
  background-color: #fafafa;
  border: 1px solid #d9d9d9;
  border-bottom: 0;
  border-radius: 2px;
}
.cmx-page-drawer .ant-collapse > .ant-collapse-header {
  border-bottom: 1px solid #d9d9d9;
}
.cmx-page-drawer .ant-collapse .ant-collapse-content > .ant-collapse-content-box {
  padding: 16px 16px;
  border-radius: 2px;
  border-bottom: 1px solid #d9d9d9;
}
.cmx-page-drawer .ant-collapse > .ant-collapse-item:last-child > .ant-collapse-header {
  border-radius: 2px;
  border-bottom: 1px solid #d9d9d9;
}
.cmx-root-layout .ant-input {
  border-radius: 2px;
}
.cmx-root-layout .ant-select {
  border-radius: 2px;
}
.cmx-root-layout .ant-table-wrapper .ant-table.ant-table-bordered > .ant-table-container {
  border-radius: 0px;
}
.cmx-root-layout .ant-btn {
  border-radius: 2px;
}
.cmx-root-layout .ant-btn-primary {
  color: #fff;
  border-color: #1890ff;
  background: #1890ff;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
}
.cmx-root-layout .ant-pagination .ant-pagination-prev .ant-pagination-item-link {
  display: block;
  width: 100%;
  height: 100%;
  padding: 0;
  font-size: 12px;
  text-align: center;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  outline: none;
  transition: all 0.3s;
}
.cmx-root-layout .ant-pagination .ant-pagination-next .ant-pagination-item-link {
  display: block;
  width: 100%;
  height: 100%;
  padding: 0;
  font-size: 12px;
  text-align: center;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  outline: none;
  transition: all 0.3s;
}
.cmx-root-layout .ant-pagination-disabled .ant-pagination-item-link,
.cmx-root-layout .ant-pagination-disabled:hover .ant-pagination-item-link {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  cursor: not-allowed;
}
.cmx-root-layout .ant-pagination .ant-pagination-item {
  display: inline-block;
  min-width: 32px;
  height: 32px;
  margin-right: 8px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
  line-height: 30px;
  text-align: center;
  vertical-align: middle;
  list-style: none;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  outline: 0;
  cursor: pointer;
  user-select: none;
}
.cmx-root-layout .ant-pagination .ant-pagination-item-active {
  font-weight: 500;
  background: #fff;
  border-color: #1890ff;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
